<div class="container">
    @if (autoLogin.isLoading()) {
        <div class="loading-wrapper">
            <div class="loader-container">
                <img src="assets/loading.gif" />
                <div>Loading Application</div>
            </div>
        </div>
    } @else if (isNonBaseRoute()) {
        <router-outlet></router-outlet>
    } @else {
        @defer (on viewport) {
            <pf-base>
                <router-outlet></router-outlet>
            </pf-base>
        } @placeholder {
            <div class="h-100 w-100 d-flex align-items-center justify-content-center">
                <div class="loader-container">
                    <img src="assets/loading.gif" />
                    <div>Loading Application</div>
                </div>
            </div>
        }
    }
</div>
